import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import React from "react";
import DialogHeader from "../../DialogHeader";
import LabelTextComponent from "../../LabelTextComponent";
import dayjs from "dayjs";

const ViewTransportDialog = ({
  open = false,
  handleClose = () => {},
  viewDialogData,
  handleEditDialogOpen = () => {},
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => handleClose()}
      PaperProps={{
        sx: { minWidth: { xs: "98%", md: "600px" } },
      }}
    >
      <DialogTitle sx={{ p: "0 !important" }}>
        <DialogHeader
          title="Transport Detail"
          handleClose={() => handleClose()}
        />
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }} />
        <Grid container spacing={1}>
          <Grid item xs={6} md={3}>
            <LabelTextComponent label={"Using"} text={viewDialogData?.using} />
          </Grid>
          <Grid item xs={6} md={6}>
            <LabelTextComponent
              label={"Route No (Route Name)"}
              text={`${viewDialogData?.routeInfo?.routeNumber}:${viewDialogData?.routeInfo?.routeName}`}
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <LabelTextComponent
              label={"Range Code"}
              text={viewDialogData?.rangeCode ?? "--"}
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <LabelTextComponent
              label={"Fee Amount"}
              text={viewDialogData?.feeAmount ? `₹${viewDialogData?.feeAmount}` : "--"}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <LabelTextComponent
              label={"Transport Vehicle (Nick Name)"}
              text={`${viewDialogData?.transportInfo?.vehicleNumber || "--"} (${viewDialogData?.transportInfo?.vehicleNickName || "--"})`}
            />
          </Grid>
          
          <Grid item xs={3}>
            <LabelTextComponent
              label={"Start Date"}
              text={
                viewDialogData?.startDate
                  ? dayjs(viewDialogData?.startDate).format("DD MMM, YYYY")
                  : "--"
              }
            />
          </Grid>
          <Grid item xs={6} md={5}>
            <LabelTextComponent label={"Stop Name"} text={viewDialogData?.to} />
          </Grid>

          <Grid item xs={12}>
            <LabelTextComponent
              label={"Remarks (if any)"}
              text={viewDialogData?.remarks ?? "--"}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="secondary"
          size="large"
          onClick={() => handleEditDialogOpen()}
        >
          EDIT
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewTransportDialog;
